<template>
  <div class="flex mb-3 x12"><Loader color="white" text=""></Loader></div>
</template>

<script>
// NOTE: This component exists for the infinite loader so
//       the default values of the Loader can be overwritten
//       to achieve consistency in its look with the rest of the site.
//       There could very well be a simpler way to do it--I just couldn't get
//       the infinite scroll plugin to accept the ways I tried other
//       than this.
export default {
  name: "InfiniteScrollLoader",
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
};
</script>
